export type AutoLogoutDurationMinutes = 30 | 60 | 120 | 180 | 360

export const DEFAULT_AUTO_LOGOUT_MINUTES: AutoLogoutDurationMinutes = 60
export const AUTO_LOGOUT_STORAGE_KEY = "sigma:autoLogoutDurationMinutes"
export const AUTO_LOGOUT_CHANGED_EVENT = "sigma-auto-logout-duration-changed"

export const AUTO_LOGOUT_DURATION_OPTIONS: Array<{ label: string; value: AutoLogoutDurationMinutes }> = [
  { label: "30분", value: 30 },
  { label: "1시간", value: 60 },
  { label: "2시간", value: 120 },
  { label: "3시간", value: 180 },
  { label: "6시간", value: 360 },
]

const LONG_AUTO_LOGOUT_DURATIONS = new Set<AutoLogoutDurationMinutes>([120, 180, 360])

export function isValidAutoLogoutDuration(value: number): value is AutoLogoutDurationMinutes {
  return AUTO_LOGOUT_DURATION_OPTIONS.some(option => option.value === value)
}

export function coerceAutoLogoutDuration(value: unknown): AutoLogoutDurationMinutes | null {
  const parsed = typeof value === "number" ? value : Number(value)

  if (!Number.isFinite(parsed) || !isValidAutoLogoutDuration(parsed)) {
    return null
  }

  return parsed
}

export function getStoredAutoLogoutDurationMinutes(): AutoLogoutDurationMinutes {
  const storedValue = coerceAutoLogoutDuration(localStorage.getItem(AUTO_LOGOUT_STORAGE_KEY))
  return storedValue ?? DEFAULT_AUTO_LOGOUT_MINUTES
}

export function setStoredAutoLogoutDurationMinutes(minutes: AutoLogoutDurationMinutes) {
  localStorage.setItem(AUTO_LOGOUT_STORAGE_KEY, String(minutes))
  window.dispatchEvent(
    new CustomEvent(AUTO_LOGOUT_CHANGED_EVENT, {
      detail: { minutes },
    })
  )
}

export function shouldConfirmLongAutoLogoutDuration(minutes: AutoLogoutDurationMinutes) {
  return LONG_AUTO_LOGOUT_DURATIONS.has(minutes)
}

export function getAutoLogoutTimeoutMs(minutes: AutoLogoutDurationMinutes) {
  return minutes * 60 * 1000
}

export function resolveAutoLogoutDurationMinutes(...values: unknown[]): AutoLogoutDurationMinutes {
  for (const value of values) {
    const resolvedValue = coerceAutoLogoutDuration(value)
    if (resolvedValue) {
      return resolvedValue
    }
  }

  return DEFAULT_AUTO_LOGOUT_MINUTES
}